import React from 'react'
import { Box, Stack, Badge, FormControl, Input } from '@/components/lib'

export default function ShortText ({ dataType, value, onChange }) {
  return (
    <Box>
      <FormControl
        helperText={value &&
          <Stack spacing={2} direction='row'>
            {dataType?.minimumLength && <Badge colorPalette={value.length < dataType.minimumLength ? 'red' : 'green'}>Min length: {dataType.minimumLength}</Badge>}
            {dataType?.maximumLength && <Badge colorPalette={value.length > dataType.maximumLength ? 'red' : 'green'}>Max length: {dataType.maximumLength}</Badge>}
          </Stack>}
      >
        <Input bg='bg.surface' value={value || ''} onChange={e => onChange(e.target.value)} />
      </FormControl>
    </Box>
  )
}
